export const gettingStarted = `https://operatorframework.io`;
export const sdkQuickstartBundle = `https://sdk.operatorframework.io/docs/olm-integration/quickstart-bundle/`;
export const manageOperatorWithOlm = `https://olm.operatorframework.io`;
export const introBlog = `https://www.redhat.com/en/blog/introducing-operators-putting-operational-knowledge-into-software`;
export const privacyPolicy = `https://www.redhat.com/en/about/privacy-policy`;
export const semanticVersioning = `https://semver.org/`;
export const socialHubX = `https://x.com/operatorhubio`;
export const socialHubYoutube = 'https://www.youtube.com/watch?v=yzPvPJLxCl8&list=PLaR6Rq6Z4Iqcuu758T4YX6KRa1158v3Rb';
export const socialKubernetesSlack = `https://kubernetes.slack.com/messages/kubernetes-operators`;

export const operatorsDocumentation = `https://k8s-operatorhub.github.io/community-operators`
export const operatorsRepo = `https://github.com/k8s-operatorhub/community-operators`;
export const operatorsFrameworkRepo = 'https://github.com/operator-framework';

export const operatorsRepoBeforePR = `${operatorsDocumentation}/contributing-prerequisites`;
export const operatorsRepoRequirements = `${operatorsDocumentation}/packaging-operator`;
export const operatorBundle = `${operatorsDocumentation}#add-your-operator`;
export const manualTestingOnKubernetes = `${operatorsDocumentation}/operator-test-suite`;
export const operatorMetadataValidation = `${operatorsDocumentation}/testing-operators`;
export const buildYourCSV = `${operatorsDocumentation}/packaging-operator`;
export const createPackageManifest = `${operatorsDocumentation}/packaging-operator`;
export const createBundle = `${operatorsDocumentation}/packaging-operator/#package-your-operator`;
export const packagemanifestToBundle = `${operatorsDocumentation}/packaging-operator/#moving-from-packagemanifest-to-bundle-format`;

export const contributions = `${operatorsRepo}/tree/main/operators`;
export const fileAnIssue = `${operatorsRepo}/issues`;

export const operatorCourier = `${operatorsFrameworkRepo}/operator-courier`;

export const operatorRegistry = `${operatorsFrameworkRepo}/operator-registry`;
export const bundleAnnotations = `${operatorRegistry}/blob/master/docs/design/operator-bundle.md#bundle-annotations`;
export const bundleDockerfile = `${operatorRegistry}/blob/master/docs/design/operator-bundle.md#bundle-dockerfile`;

export const operatorSdk = `${operatorsFrameworkRepo}/operator-sdk`;
export const operatorScorecard = `${operatorSdk}/blob/master/doc/test-framework/scorecard.md`;
export const capabilityLevelModelDiagram = `${operatorSdk}/blob/master/doc/images/operator-capability-level.png`;
export const sampleCode = `${operatorSdk}/tree/master/testdata/go/v4/memcached-operator/internal/controller/memcached_controller.go#L81-L283`;

export const olm = `${operatorsFrameworkRepo}/operator-lifecycle-manager`;
export const olmArchitecture = `${olm}/blob/master/doc/design/architecture.md`;
export const operatorGroupDesign = `${olm}/blob/master/doc/design/architecture.md#operator-group-design`;
export const discoveryCatalogs = `${olm}#discovery-catalogs-and-automated-upgrades`;
